class HttpResponse {
  isSuccessStatusCode = false
  statusCode = null
  body = null
  headers = null
}

export default HttpResponse
